import { useTranslation } from "next-i18next";
import { Typography, Grid, Box, Container } from "@mui/material";
import PhoneInput from "@components/common/PhoneInput";
import { colors } from "@theme/colors";

const styles = {
  section: {
    mt: 8,
    pt: 20,
    pb: 13,
    backgroundImage: {
      xs: "url('/assets/images/growing_guidance/footer_mobile.svg')",
      md: "url('/assets/images/growing_guidance/footer.svg')",
    },
    backgroundSize: "cover",
    backgroundPositon: "top center",
  },
};

export default function SecondaryFooter() {
  const { t } = useTranslation("common");

  return (
    <>
      <Box sx={styles.section}>
        <Container>
          <Grid container justifyContent="center" alignItems="center">
            <Grid item xs={11} sm={9} md={7} textAlign={"center"}>
              <Box>
                <Typography variant="h3" color="text.primary">
                  {t("join_community_heading")}
                </Typography>
                <Typography
                  variant="h5"
                  color="text.primary"
                  mt={4.3}
                  mx={"10%"}
                  p={"auto"}
                  fontFamily="Inter"
                >
                  {t("join_community_text")}
                </Typography>
              </Box>
              <Box mt={5}>
                <PhoneInput
                  inputProps={{
                    style: {
                      backgroundColor: "#f9efec",
                      color: colors.primary.purple,
                    },
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
}
